<template>
  <div class="paper-appraise-arrange-add" v-loading="loading" element-loading-text="数据加载中，请稍等...">
    <div class="cont" v-if="teacherList.length">
      <el-form size="mini" label-width="100px" label-suffix="：">
        <el-form-item label="评阅教师" required>
          <el-select v-model="teacherIds" placeholder="请选择评阅教师">
            <el-option v-for="teacher in teacherList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" :loading="committing" @click="handleSubmit">{{ committing ? '提交中...' : '提交' }}</el-button>
      </div>
    </div>
    <Hint v-else v-show="errorMsg">{{ errorMsg }}</Hint>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperAppraiseArrangeAdd',
  components: {
    Hint
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    extraId: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      teacherList: [],
      teacherIds: []
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/appraise/arrange/queryTeacher',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.teacherList = response.data.teacherList || []
          if (!this.teacherList.length) {
            this.errorMsg = '暂无评阅教师'
          }
        } else {
          this.errorMsg = response.data.message || '获取评阅教师失败'
        }
      }, () => {
        this.errorMsg = '获取评阅教师失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      if (!this.teacherIds.length) {
        this.$message.warning('请选择评阅教师')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/paper/appraise/arrange/saveArrange',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId,
          teacherIds: this.teacherIds,
          postIds: this.extraId
        }, {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success('提交成功')
          this.$emit('hidePopoverAndRefresh')
        } else {
          this.$message.error(response.data.message || '提交失败')
        }
      }, () => {
        this.$message.error('提交失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          this.teacherIds = []
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-appraise-arrange-add{
  height: 200px;
  & > .cont{
    height: 100%;
    display: flex;
    flex-direction: column;
    ::v-deep  .el-form{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      overflow-y: auto;
      & > .el-form-item{
        & > .el-form-item__label{
          font-size: 12px;
        }
        & > .el-form-item__content{
          & > .el-select{
            width: 260px;
          }
        }
      }
    }
    & > .footer{
      padding: 10px 0;
      text-align: center;
      background-color: #fff;
    }
  }
}
</style>
